import { render, staticRenderFns } from "./InvestorTips.vue?vue&type=template&id=01f16ade&scoped=true&"
import script from "./InvestorTips.vue?vue&type=script&lang=ts&"
export * from "./InvestorTips.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f16ade",
  null
  
)

export default component.exports